<template>
  <div class="pis-clock">
    <span class="data">{{ currentTime }}</span>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  data () {
    return {
      currentTime: moment().format('LT'),
    }
  },
  async created () {
    const { data: serverDateTime} = await axios.get(this.route('current-time'))

    const serverOffset = moment(serverDateTime).diff(new Date())

    setInterval(() => {
      this.currentTime =  moment().add(serverOffset, 'milliseconds').format('LT')
    }, 1000)
  },
}
</script>
